<style scoped>
    @import url("../../styles/mv/geralMv.scss");
</style>

<template>
    <div class="box_geralMv">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-weather-partly-snowy</v-icon>
            <span class="ml-2">Estação meteorológica | Serra da Gardunha</span>
        </div>

        <div class="painelGeral">
            <ImgDevice2 />
            <GraficoMv :t="'Bateria'" :payload="payload_b_st_g" :r="r" />
            <GraficoMv :t="'Umidade do ar'" :payload="payload_u_st_g" :r="r" />
            <GraficoMv :t="'Pressão'" :payload="payload_p_st_g" :r="r" />
            <GraficoMv :t="'Temperatura do ar'" :payload="payload_t_st_g" :r="r" />
            <GraficoMv :t="'Direção vento [°]'" :payload="payload_wd_st_g" :r="r" />
            <GraficoMv :t="'Velocidade do vento'" :payload="payload_ws_st_g" :r="r" />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-chart-line</v-icon>
            <span class="ml-2">Sensor solo | Serra da Gardunha</span>
        </div>

        <div class="painelGeral">
            <GraficoMv :t="'Condutividade elétrica'" :payload="payload_ec_ss_g" :r="r" />
            <GraficoMv :t="'Temperatura solo'" :payload="payload_t_ss_g" :r="r" />
            <GraficoMv :t="'Umidade solo'" :payload="payload_u_ss_g" :r="r" />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-weather-partly-snowy</v-icon>
            <span class="ml-2">Estação meteorológica | Quinta Experimental Fundão</span>
        </div>

        <div class="painelGeral">
            <ImgDevice />
            <GraficoMv :t="'Bateria'" :payload="payload_b_st_q" :r="r" />
            <GraficoMv :t="'Umidade do ar'" :payload="payload_u_st_q" :r="r" />
            <GraficoMv :t="'Pressão'" :payload="payload_p_st_q" :r="r" />
            <GraficoMv :t="'Temperatura do ar'" :payload="payload_t_st_q" :r="r" />
            <GraficoMv :t="'Direção vento [°]'" :payload="payload_wd_st_q" :r="r" />
            <GraficoMv :t="'Velocidade do vento'" :payload="payload_ws_st_q" :r="r" />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-chart-line</v-icon>
            <span class="ml-2">Sensor solo | Quinta Experimental Fundão</span>
        </div>

        <div class="painelGeral">
            <GraficoMv :t="'Condutividade elétrica'" :payload="payload_ec_ss_q" :r="r" />
            <GraficoMv :t="'Temperatura solo'" :payload="payload_t_ss_q" :r="r" />
            <GraficoMv :t="'Umidade solo'" :payload="payload_u_ss_q" :r="r" />
        </div>

    </div>
</template>

<script>
import GraficoMv from './GraficoMv'
import ImgDevice from './ImgDevice'
import ImgDevice2 from './ImgDevice2'

//import Img_st_g from '../../assets/capa-up-t1.png'

export default {

    components:{GraficoMv,ImgDevice,ImgDevice2},

    data() {
        return {
            //
            r:'/readingdevice',

            //img_st_g:'../../assets/capa-up-t1.png',

            payload_ec_ss_g:{"cliente":"orange1","marcador":"sensor_ec_g","name_key":"conductivity"},
            payload_t_ss_g:{"cliente":"orange1","marcador":"sensor_t_g","name_key":"temperature"},
            payload_u_ss_g:{"cliente":"orange1","marcador":"sensor_u_g","name_key":"humidity"},

            payload_ec_ss_q:{"cliente":"orange1","marcador":"sensor_ec_q","name_key":"conductivity"},
            payload_t_ss_q:{"cliente":"orange1","marcador":"sensor_t_q","name_key":"temperature"},
            payload_u_ss_q:{"cliente":"orange1","marcador":"sensor_u_q","name_key":"humidity"},

            payload_b_st_g:{"cliente":"orange1","marcador":"station_b_g","name_key":"battery"},
            payload_u_st_g:{"cliente":"orange1","marcador":"station_u_g","name_key":"humidity"},
            payload_p_st_g:{"cliente":"orange1","marcador":"station_p_g","name_key":"pressure"},
            payload_t_st_g:{"cliente":"orange1","marcador":"station_t_g","name_key":"temperature"},
            payload_wd_st_g:{"cliente":"orange1","marcador":"station_wd_g","name_key":"wind_direction"},
            payload_ws_st_g:{"cliente":"orange1","marcador":"station_ws_g","name_key":"wind_speed"},

            payload_b_st_q:{"cliente":"orange1","marcador":"station_b_q","name_key":"battery"},
            payload_u_st_q:{"cliente":"orange1","marcador":"station_u_q","name_key":"humidity"},
            payload_p_st_q:{"cliente":"orange1","marcador":"station_p_q","name_key":"pressure"},
            payload_t_st_q:{"cliente":"orange1","marcador":"station_t_q","name_key":"temperature"},
            payload_wd_st_q:{"cliente":"orange1","marcador":"station_wd_q","name_key":"wind_direction"},
            payload_ws_st_q:{"cliente":"orange1","marcador":"station_ws_q","name_key":"wind_speed"},
        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        //this.img1 = this.Img_st_g
        //console.log('this.Img_st_g: ',this.Img_st_g)
    }
}
</script>